import { render, staticRenderFns } from "./NewsSectionPreview.vue?vue&type=template&id=65621f26&scoped=true&"
import script from "./NewsSectionPreview.vue?vue&type=script&lang=js&"
export * from "./NewsSectionPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65621f26",
  null
  
)

export default component.exports